import { useNavigate, useParams } from 'react-router-dom';
import { CpmCard, CpmPageShell, CpmTabBar, CpmTooltip } from '../../components/design-system';
import type { ConfigTemplateLevel } from '../../types/configTemplate.types';
import { CONFIG_TEMPLATE_COPY, listPath } from './configTemplateCopy';
import TemplatesList from './components/TemplatesList';

function levelFromParam(place?: string): ConfigTemplateLevel {
    return place === 'store-level' ? 'STORE' : 'STORE_BRAND';
}

function InfoIcon() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4M12 8h.01" strokeLinecap="round" />
        </svg>
    );
}

export default function ConfigTemplates() {
    const { place } = useParams<{ place?: string }>();
    const navigate = useNavigate();
    const level = levelFromParam(place);

    return (
        <CpmPageShell gap={20} maxWidth={1440} variant="compactBottom">
            <div className="flex items-center" style={{ gap: 9 }}>
                <h1
                    className="m-0"
                    style={{
                        fontSize: 30,
                        fontWeight: 800,
                        letterSpacing: '-0.025em',
                        color: 'var(--cpm-text-primary)',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {CONFIG_TEMPLATE_COPY.TITLE}
                </h1>
                <CpmTooltip content={CONFIG_TEMPLATE_COPY.HEADING_TOOLTIP} align="start" fit>
                    <span
                        className="inline-flex items-center"
                        style={{ color: 'var(--cpm-text-tertiary)' }}
                    >
                        <InfoIcon />
                    </span>
                </CpmTooltip>
            </div>

            <CpmCard>
                <CpmTabBar
                    value={level}
                    onChange={(next) => navigate(listPath(next as ConfigTemplateLevel))}
                    tabs={[
                        { value: 'STORE_BRAND', label: CONFIG_TEMPLATE_COPY.PLACE_BRAND },
                        { value: 'STORE', label: CONFIG_TEMPLATE_COPY.PLACE_STORE },
                    ]}
                />
                <TemplatesList key={level} level={level} />
            </CpmCard>
        </CpmPageShell>
    );
}
